module.exports = __webpack_public_path__ + "img/step4.a95e4e1d.png";